<template>
	<img class="mr-4" id="avatar" alt="Character image">
</template>

<script>
export default {
	
}
</script>

<style scoped>

</style>